import TechSvg from '../../../assets/tech.svg?react';
import { IconProps } from '../../types/IconProps';

export function Tech({ size = 20, ...props }: IconProps) {
  return <TechSvg data-testid="tech-icon" width={size} height={size} {...props} />;
}

export default Tech;
